// 获取落地页类型列表
export function getLandingPageClass(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adLandingPage/dataList',
    data
  })
}

// 落地页列表
export function getLandingPageList(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adLandingPage/pageList',
    data
  })
}

// 落地页详情
export function getLandingPageInfo(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adLandingPage/data',
    data
  })
}

// 新增
export function addLandingPage(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adLandingPage/addLandingPage',
    data
  })
}

// 更新
export function editLandingPage(data) {
  return this.fetch({
    method: 'post',
    url: 'api/dsp/adLandingPage/editLandingPage',
    data
  })
}
